import React, { Component } from 'react';

class warning extends Component {
  render() {
    return //(

    //    );
  }
}

//<div className="Warning">
//<p style={{ textAlign: "center" }}>
//  This page is a demo. Contact info at
//  <a href="https://csfrederick.com/contact"> csfrederick.com/contact</a>
//</p >
//      </div >

export default warning;